import React from 'react';
import ApexCharts from 'react-apexcharts';

const PieChartComponentCoordinator = ({ totalScoresCoordinator }) => {
  console.log("totalScoresCoordinatorPiecoor",totalScoresCoordinator)
  // Define a function to assign color based on the score range
  const generateColor = (averageScore) => {
    if (averageScore >= 0 && averageScore <= 24.9) {
      return "#ED0530"; 
    } else if (averageScore >= 25 && averageScore <= 27.9) {
      return "#F46983"; 
    } else if (averageScore >= 28 && averageScore <= 29.9) {
      return "#FF7800"; 
    } else if (averageScore >= 29 && averageScore <= 30.9) {
      return "#FFAE66"; 
    } else if (averageScore >= 31 && averageScore <= 32.9) {
      return "#73C272"; 
    } else {
      return "#489547"; 
    }
  };
  const topFiveGroups = totalScoresCoordinator
  .sort((a, b) => parseFloat(b.averageScore) - parseFloat(a.averageScore)) // Sort in descending order
  .slice(0, 5); 
  // Map colors, series, and labels for the pie chart
  const colorsPie = topFiveGroups.map(item => generateColor(parseFloat(item.averageScore))); // Assign colors based on score
  const seriesPie = topFiveGroups.map(item => parseFloat(item.averageScore)); // Ensure values are numeric for the series
  const labelsPie = topFiveGroups.map(item => item.groupName);
 


//prod code
  const pieOptionsCoordinator = {
    chart: {
      type: 'pie',
      height: 350,
    },
    labels: labelsPie,
    colors: colorsPie,
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return `${opts.w.config.series[opts.seriesIndex].toFixed(1)}`; // Show numeric values without '%'
      },
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        colors: ['#FFFFFF'], // Set text color to white
        textShadow: 'none',  // Remove any text shadow
      },
      dropShadow: {
        enabled: false,  // Disables any drop shadow effect from ApexCharts
      },
    },
    tooltip: {
      y: {
        formatter: function(value) {
          return value.toFixed(2); // Format tooltip to display two decimal points
        }
      }
    },
    legend: {
      show: true,
      position: 'bottom',
    },
    
  };

  return (
    <div>
        {seriesPie.length > 0 ? (
      <ApexCharts options={pieOptionsCoordinator} series={seriesPie} type="pie" height={350} />
    ) : (
      <p>No data available for the selected month and year.</p>
    )}
      {/* <ApexCharts options={pieOptionsCoordinator} series={seriesPie} type="pie" height={350} /> */}
    </div>
  );
};

export default PieChartComponentCoordinator;
